<template>
  <div class="handlePicList" v-if="handlePicList.length>0">
  <div v-for="(item,index) in handlePicList" :key="index" class="item">
    <el-image
      :style="` display: block; max-width: 100%; max-height: 600px;width:${width}px;height:${height}px;margin: 0 auto`"
      :src="item"
      :preview-src-list="handlePicList">
    </el-image>
  </div>
  </div>
</template>

<script>

export default {
  name: "ImagePreviewList",
  data(){
    return {
      dialogImageUrl:"",
      dialogVisible:false,
    }
  },
  props: {
    picList: {
      type: String,
      required: true
    },
    width: {
      type: [Number, String],
      default: ""
    },
    height: {
      type: [Number, String],
      default: ""
    },
    coupleWidth: {
      type: [Number, String],
      default: ""
    },
    coupleHeight: {
      type: [Number, String],
      default: ""
    },
    simpleWidth: {
      type: [Number, String],
      default: ""
    },
    simpleHeight: {
      type: [Number, String],
      default: ""
    },
  },
  computed: {

    handlePicList() {
      let list = [];
      if (this.picList) {
        // 首先将值转为数组
       list = this.picList.split(',');
      }
      return list;
    },
    // realSrc() {
    //   let real_src = this.src.split(",")[0];
    //   if (isExternal(real_src)) {
    //     return real_src;
    //   }
    //   return process.env.VUE_APP_BASE_API + real_src;
    // },
    // realSrcList() {
    //   let real_src_list = this.src.split(",");
    //   let srcList = [];
    //   real_src_list.forEach(item => {
    //     if (isExternal(item)) {
    //       return srcList.push(item);
    //     }
    //     return srcList.push(process.env.VUE_APP_BASE_API + item);
    //   });
    //   return srcList;
    // },
    realCoupleWidth() {
      return typeof this.width == "string" ? this.coupleWidth : `${this.coupleWidth}px`;
    },
    realCoupleHeight() {
      return typeof this.height == "string" ? this.coupleHeight : `${this.coupleHeight}px`;
    },
    realSimpleWidth() {
      return typeof this.width == "string" ? this.simpleWidth : `${this.simpleWidth}px`;
    },
    realSimpleHeight() {
      return typeof this.height == "string" ? this.simpleHeight : `${this.simpleHeight}px`;
    }
  },
};
</script>

<style lang="scss" scoped>
.el-image {
  border-radius: 5px;
  background-color: #ebeef5;
  box-shadow: 0 0 5px 1px #ccc;
  ::v-deep .el-image__inner {
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      transform: scale(1.2);
    }
  }
  ::v-deep .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 30px;
  }
}
.handlePicList{
  display: flex;
}
.item{
  margin-right: 5px;
}
.item  .el-image{
  background: none;
  box-shadow: 0px 0px 0px 0px #ffff;
  border:1px solid #c0ccda;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/ImagePreviewList.vue